import React, { useState } from "react";

import { useContext } from "../Context";
import Table from "./Table";

export default function Index() {
  const { dispatch, actions, state } = useContext();

  return (
    <>
      {state.viewMode == "view" && (
        <div className="ibox-content mt20">
          <h1>Invoice History</h1>
          <Table adminView={true} />
        </div>
      )}
    </>
  );
}
